export default __webpack_public_path__ + "static/media/question.74387c7a.png";